import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize} from 'rxjs/operators';

import { LoaderService } from '@app/core/services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEventType.Response>> {

    // the zero timeout makes sure that ExpressionChangedAfterItHasBeenCheckedError doesn't occur
    setTimeout(() => this.loaderService.onRequestStarted(), 0);

    return next.handle(req).pipe(
        finalize(() => this.loaderService.onRequestCompleted())
    );
  }
}


